import { Routes, Route } from "react-router-dom";
import EngagePlan from "./components/Clientpanel/EngagementPlannerV1/EngagePlan";
import { AuthProvider } from "./hooks/useEngageV1Auth";
import { MerchantProvider } from "./hooks/useMerchantEngageV1";

const EngageRoutes = () => {
  return (
    <AuthProvider>
      <MerchantProvider>
      <Routes>
        <Route path="dashboard" element={<EngagePlan />} />
        <Route path="campaigns" element={<EngagePlan />} />
        <Route path="campaigns/new" element={<EngagePlan />} />
        <Route path="outreach" element={<EngagePlan />} />
        <Route path="/outreach/new" element={<EngagePlan />} />
        <Route path="/outreach/:id" element={<EngagePlan />} />
        <Route path="calendar" element={<EngagePlan />} />
        <Route path="customers/:id" element={<EngagePlan />} />
        <Route path="customers" element={<EngagePlan />} />
        <Route path="/templates/:id/preview" element={<EngagePlan />} />
        <Route path="/templates/:id/edit" element={<EngagePlan />} />
        <Route path="templates/new" element={<EngagePlan />} />
        <Route path="templates" element={<EngagePlan />} />
        <Route path="automations" element={<EngagePlan />} />
        <Route path="analytics" element={<EngagePlan />} />
        <Route path="settings" element={<EngagePlan />} />
      </Routes>
      </MerchantProvider>
    </AuthProvider>
  );
};

export default EngageRoutes;